import { render, staticRenderFns } from "./ReviewOtherFieldValues.vue?vue&type=template&id=3810c7be&scoped=true"
import script from "./ReviewOtherFieldValues.vue?vue&type=script&lang=js"
export * from "./ReviewOtherFieldValues.vue?vue&type=script&lang=js"
import style0 from "./ReviewOtherFieldValues.vue?vue&type=style&index=0&id=3810c7be&prod&scoped=true&lang=css"
import style1 from "./ReviewOtherFieldValues.vue?vue&type=style&index=1&id=3810c7be&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3810c7be",
  null
  
)

export default component.exports